// src/mocks/data/vertical.js
// Resolves the active demo vertical (business_type) from URL / sessionStorage.
// Codes match Business.BUSINESS_TYPE_CHOICES in core/models.py.

const VALID_BUSINESS_TYPES = ["beauty", "medical_clinic"];
const DEFAULT_BUSINESS_TYPE = "beauty";

export function getBusinessTypeFromUrl() {
  if (typeof window === "undefined") return DEFAULT_BUSINESS_TYPE;
  // index.jsx salveaza ?business_type= in sessionStorage inainte de orice navigare.
  const stored = sessionStorage.getItem("demo_business_type") || "";
  const fromUrl = new URLSearchParams(window.location.search).get("business_type") || "";
  const v = stored || fromUrl;
  return VALID_BUSINESS_TYPES.includes(v) ? v : DEFAULT_BUSINESS_TYPE;
}
